<script setup lang="ts">
  defineProps<{
    message: string;
  }>();
</script>

<template>
  <div
    data-testid="settings-section-empty-state"
    class="flex min-h-40 flex-col items-center justify-center px-6 py-4 text-center"
  >
    <p class="text-sm text-gray-05">
      {{ message }}
    </p>
  </div>
</template>
